var render = function render(){var _vm=this,_c=_vm._self._c;return _c('client-only',[_c('pdf',{attrs:{"src":_vm.src,"page":_vm.page}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }